import React from 'react';
export const PerformanceSection = () => {
  // Updated performance data with the specified years and percentages
  const performanceData = [{
    year: 'FY 2026 (till date)',
    growth: 17.15,
    benchmark: 5.75
  }, {
    year: 'FY 2025',
    growth: 5.36,
    benchmark: -1.15
  }, {
    year: 'FY 2024',
    growth: 19.94,
    benchmark: 16.3
  }, {
    year: 'FY 2023',
    growth: 21.95,
    benchmark: 18.05
  }];
  return <section id="performance" className="py-16 bg-white" data-id="element-146" data-mp="1be3diqo42afd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147" data-mp="1bciikzxvwpgz">
        <div className="lg:text-center" data-id="element-148" data-mp="1gd6kignniqpz">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-149" data-mp="1ge7yasw1xrbe">
            Our Track Record
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-150" data-mp="3i52v9o1zvwjp">
            Performance History
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-151" data-mp="3n4foqrndg1v9">
            A consistent history of returns that have outperformed the Indian
            market benchmark.
          </p>
        </div>
        <div className="mt-16" data-id="element-152" data-mp="3qywhwoar5a6u">
          <div className="overflow-x-auto" data-id="element-153" data-mp="3m0v2qegg5v0n">
            <table className="min-w-full divide-y divide-slate-200" data-id="element-154" data-mp="3m1wc8ehte9g9">
              <thead className="bg-slate-50" data-id="element-155" data-mp="3h2t8cxdkm99v">
                <tr data-id="element-156" data-mp="3h3utjuoawc5b">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-157" data-mp="ike7ifxc9ik2">
                    Year
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-158" data-mp="8lgm3lv7m55a">
                    Aurum Grove Performance
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-159" data-mp="2ta4c8rlz55xs">
                    Nifty 50
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-160" data-mp="2vrnixygo7r4s">
                    Outperformance
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200" data-id="element-161" data-mp="281t8tonqkgo8">
                {performanceData.map(item => <tr key={item.year} data-id="element-162" data-mp="2cshzj1rld9mb">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-163" data-mp="2ctkubks1bw7i">
                      {item.year}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700" data-id="element-164" data-mp="231nbbrusbzy8">
                      {item.growth}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700" data-id="element-165" data-mp="1p4s13w2ss2gl">
                      {item.benchmark}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-[#D4AF37] font-medium" data-id="element-166" data-mp="1ah04h4kmqqlu">
                      {(item.growth - item.benchmark).toFixed(1)}%
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="mt-10 text-center" data-id="element-167" data-mp="1ehakzb61szey">
            <p className="text-sm text-slate-500" data-id="element-168" data-mp="1eg8zsdvbiwji">
              Note: Past performance is not indicative of future results.
              Performance is benchmarked against the Nifty 50 Index. The above
              figures are for illustration purposes only.
            </p>
          </div>
        </div>
      </div>
    </section>;
};